import ApiRequestManagerInstance from '../ApiRequestManager';
import FlavourConfig from '../../../shared/config/flavours';
import { IConfigRequest, IConfig } from '../../types/interfaces/config';

export default function configRequest() {
  const promise = new Promise<IConfig[]>(async (resolve, reject) => {
    try {
      const response: IConfigRequest = (await ApiRequestManagerInstance.get({
        endpoint: {
          url: 'cdnSyncUrl',
          section: 'media',
          subsection: 'params',
          type: 'config',
          params: FlavourConfig.apiService + '.json',
        },
      })) as IConfigRequest;

      resolve(response.data);
    } catch (e) {
      reject([]);
    }
  });

  return promise;
}
